var exports = {
  "X": "DomainList__rKhEda",
  "x": "ShowMore__34of3F",
};

module.exports = exports;
